<template>
    <div :class="className?className:'index-social'">
        <a
            target="_blank"
            v-if="$root.siteConfig.site_settings.social && $root.siteConfig.site_settings.social.facebook"
            :href="$root.siteConfig.site_settings.social.facebook"
        >
            <i class="icofont-facebook"></i>
        </a>
        <a
            target="_blank"
            v-if="$root.siteConfig.site_settings.social && $root.siteConfig.site_settings.social.youtube"
            :href="$root.siteConfig.site_settings.social.youtube"
        >
            <i class="icofont-youtube"></i>
        </a>
        <a
            target="_blank"
            v-if="$root.siteConfig.site_settings.social && $root.siteConfig.site_settings.social.linkedin"
            :href="$root.siteConfig.site_settings.social.linkedin"
        >
            <i class="icofont-linkedin"></i>
        </a>
        <a
            target="_blank"
            v-if="$root.siteConfig.site_settings.social && $root.siteConfig.site_settings.social.twitter"
            :href="$root.siteConfig.site_settings.social.twitter"
        >
            <i class="icofont-twitter"></i>
        </a>
    </div>
</template>
<script>
export default {
    props: ["className"],
};
</script>